import { Component, Inject, OnInit } from '@angular/core';
import { InventoryService } from '../../../inventory/inventory-service.service';
import { SystemComponentViewModel } from '../../../inventory/inventory-models';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'record-action-history-popup',
    templateUrl: './record-action-history-popup.component.html',
    styleUrls: ['./record-action-history-popup.component.scss']
})
export class RecordActionHistoryPopup implements OnInit {
    equitUnitId: number;
    componentHistories: SystemComponentViewModel[];

    constructor(public dialogRef: MatDialogRef<RecordActionHistoryPopup>,
        @Inject(MAT_DIALOG_DATA) public data: any, private inventoryService: InventoryService) { }
    EquipmentData: any;
    ngOnInit(): void {
        this.equitUnitId = this.data.component;
        
        console.log(this.EquipmentData);
        this.GetEquipmentRecordHistory();
    }
    onNoClickPopup() {
        this.dialogRef.close();
        
      }
    GetEquipmentRecordHistory() {
        this.inventoryService.GetEquipmentRecordHistory(this.equitUnitId).subscribe(res => {
            if (res != null) {
                this.componentHistories = res;
            }
        })
    }

}
